/* T-Fuel Quiz ("Tradesman T-Check") — ported from the Funnelish build 2026-09-23.
   Logic is byte-for-byte the source's; the only change is that every lookup is scoped to
   the .tnq root instead of `document`, so the quiz cannot collide with theme element ids. */
(function () {
  function boot(root) {
    if (!root || root.dataset.tnqBooted) return;
    root.dataset.tnqBooted = '1';

    var steps = [].slice.call(root.querySelectorAll('[data-step]'));
    var bar = root.querySelector('[data-tnq="bar"]');
    var backBtn = root.querySelector('[data-tnq="back"]');
    if (!steps.length || !bar || !backBtn) return;

    var i = 0, answers = { cost: [] };
    var q = function (sel) { return root.querySelector('[data-tnq="' + sel + '"]'); };

    var affirm = {
      energy: ["Energy and drive is the #1 thing guys come to us for", "Energy is the #1 thing guys come to us for. It's also the first thing most of them notice coming back."],
      muscle: ["Strength dropping off is one of the clearest signs", "Strength dropping off while you're still working just as hard is one of the clearest signs your T has slipped."],
      libido: ["You're not the only one", "You're not the only one. Most guys won't say it out loud, which is exactly why it goes unfixed for years."],
      motivation: ["Motivation goes first", "When your T drops, motivation goes before anything physical does. It's the earliest signal and the most ignored."],
      recovery: ["That's testosterone's work", "Staying sore between shifts isn't just the job getting harder. It's how fast your body repairs, and that's testosterone's work."]
    };

    function render() {
      steps.forEach(function (s, n) { s.classList.toggle('active', n === i); });
      var pct = Math.round(((i + 1) / steps.length) * 100);
      bar.style.width = pct + '%';
      backBtn.classList.toggle('show', i > 0);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var el = steps[i];
      if (el.dataset.checklist) { runChecklist(el); }
      if (el.dataset.chart) {
        setTimeout(function () {
          el.querySelectorAll('.bars div').forEach(function (b, k) {
            setTimeout(function () { b.style.height = b.dataset.h + '%'; }, k * 180);
          });
        }, 150);
      }
      if (el.dataset.auto) {
        var t = parseInt(el.dataset.auto, 10);
        setTimeout(function () { if (steps[i] === el) next(); }, t);
      }
    }

    function runChecklist(el) {
      var lis = el.querySelectorAll('.loadlist li');
      lis.forEach(function (li) { li.classList.remove('on'); });
      lis.forEach(function (li, k) { setTimeout(function () { li.classList.add('on'); }, 700 + k * 1100); });
    }

    function next() { if (i < steps.length - 1) { i++; if (steps[i].dataset.summary) buildSummary(); render(); } }
    function prev() { if (i > 0) { i--; render(); } }

    backBtn.addEventListener('click', prev);

    root.addEventListener('click', function (e) {
      var b = e.target.closest('button,a');
      if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-next')) { e.preventDefault(); next(); return; }
      if (b.dataset.single) {
        var k = b.dataset.single;
        b.parentNode.querySelectorAll('[data-single="' + k + '"]').forEach(function (o) { o.classList.remove('sel'); });
        b.classList.add('sel'); answers[k] = b.dataset.value;
        if (k === 'goal') {
          var a = affirm[b.dataset.value];
          q('affirm-title').textContent = a[0];
          q('affirm-body').textContent = a[1];
        }
        setTimeout(next, 280);
      }
      if (b.dataset.multi) {
        b.classList.toggle('sel');
        var key = b.dataset.multi;
        answers[key] = [].slice.call(b.parentNode.querySelectorAll('[data-multi="' + key + '"].sel')).map(function (o) { return o.dataset.value; });
        var cta = b.parentNode.querySelector('[data-require="' + key + '"]');
        if (cta) cta.disabled = answers[key].length === 0;
      }
    });

    function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

    function buildSummary() {
      var score = 0;
      var ageMap = { '50+': 3, '40-49': 2, '30-39': 1, '20-29': 0 };
      score += ageMap[answers.age] || 0;
      score += answers.flat === 'yes' ? 2 : 0;
      score += num(answers.threepm) + num(answers.onset) + num(answers.morning) + num(answers.sleep) + num(answers.drinks) + num(answers.diet);
      score += Math.min((answers.cost || []).length, 4) * 0.5;
      var max = 22, pct = Math.min(Math.round(score / max * 100), 98);

      var level, word, body, pattern, room, recovery, needle;
      if (pct >= 60) {
        level = 'HIGH'; word = 'DECLINING'; needle = 12;
        body = "Your testosterone has dropped below where it should be. Levels fall naturally after 30, and long hours, short sleep, and poor recovery speed that up.";
        pattern = 'Progressive'; room = 'High'; recovery = 'Substantial';
      } else if (pct >= 35) {
        level = 'MODERATE'; word = 'SLIPPING'; needle = 48;
        body = "Your testosterone is trending below where it should be. The pattern is early but clear, and the load from your schedule is what's driving it down.";
        pattern = 'Early Stage'; room = 'High'; recovery = 'Noticeable';
      } else {
        level = 'MILD'; word = 'EARLY WARNING'; needle = 78;
        body = "Your levels are holding up better than most guys in your trade, but the early markers are there. This is the easiest point to turn it around.";
        pattern = 'Stable, At Risk'; room = 'Moderate'; recovery = 'Mild';
      }

      var driver = 'Age + Lifestyle Load';
      var lifestyle = num(answers.drinks) + num(answers.diet) + num(answers.sleep);
      if (lifestyle >= 6) driver = 'Lifestyle Load';
      else if ((ageMap[answers.age] || 0) >= 2 && lifestyle <= 3) driver = 'Age-Related Decline';
      if (num(answers.sleep) >= 2 && num(answers.morning) >= 2) driver = 'Sleep + Recovery Debt';

      var badge = q('declineBadge');
      badge.textContent = level;
      badge.style.background = level === 'HIGH' ? '#C4341F' : (level === 'MODERATE' ? '#C9871A' : '#1F6B3A');
      q('assessWord').textContent = word;
      q('assessBody').textContent = body;
      q('sPattern').textContent = pattern;
      q('sRoom').textContent = room;
      q('sDriver').textContent = driver;
      q('sRecovery').textContent = recovery;
      setTimeout(function () { q('needle').style.left = needle + '%'; }, 300);
    }

    render();
  }

  function init() { document.querySelectorAll('.tnq').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme editor: re-boot when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    (e.target.querySelectorAll ? e.target.querySelectorAll('.tnq') : []).forEach(boot);
  });
})();
